import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "./data";

export const Services = ({ onQuote }) => (
  <section id="services" data-testid="services-section" className="bg-brand-offwhite py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-2xl">
        <p className="eyebrow">Our Services</p>
        <h2 className="h2 mt-4">Six Core Services, One Local Partner</h2>
        <p className="lead mt-4">Practical, connected technology for Chatham-Kent businesses, from everyday IT and Microsoft 365 to cameras and advertisement TVs.</p>
      </div>
      <div className="mt-14 grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s) => (
          <ServiceCard key={s.id} service={s} onQuote={onQuote} />
        ))}
      </div>
    </div>
  </section>
);

const ServiceCard = ({ service, onQuote }) => {
  const Icon = service.icon;
  return (
    <article data-testid={`service-card-${service.id}`} className="soft-card group flex flex-col overflow-hidden transition-shadow duration-300 hover:shadow-md">
      <img src={service.image} alt={service.title} loading="lazy" className="aspect-[16/10] w-full object-cover" />
      <div className="relative flex flex-1 flex-col px-6 pb-6 pt-9">
        <span className="absolute -top-6 left-6 grid h-12 w-12 place-items-center rounded-xl border border-brand-surface bg-white shadow-sm">
          <Icon className="h-6 w-6 text-brand-blue" strokeWidth={1.6} />
        </span>
        <h3 className="font-heading text-lg font-semibold leading-snug text-brand-navy">{service.title}</h3>
        <p className="mt-2.5 flex-1 text-sm leading-relaxed text-brand-slate">{service.desc}</p>
        <div className="mt-5 flex items-center justify-between gap-3">
          <Link to={`/services/${service.slug}`} data-testid={`service-learn-more-${service.id}`} className="link-arrow">
            Learn More <ArrowRight className="h-4 w-4" />
          </Link>
          <button type="button" onClick={() => onQuote(service.title)} data-testid={`service-get-quote-${service.id}`} className="rounded-lg px-2.5 py-1.5 text-xs font-medium text-brand-slate transition-colors hover:bg-brand-offwhite hover:text-brand-blue">
            Get a quote
          </button>
        </div>
      </div>
    </article>
  );
};
